import { createRouter, createWebHashHistory } from 'vue-router';


const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'index',
    },
  },
  {
    path: '/',
    name: 'index',
    component: () => import('./view/Index'),
    meta:{title:'云上思念网上祭奠平台-网络祭拜网上祭扫-线上祭祀扫墓-为逝者创建网上纪念馆'}
  },
  {
    path: '/home/index',
    name: 'pcIndex',
    component: () => import('./view/Pc/Index'),
    meta:{title:'云上思念网上祭奠平台-网络祭拜网上祭扫-线上祭祀扫墓-为逝者创建网上纪念馆'}
  },
  {
    path: '/Mobile/Index',
    name: 'mobileIndex',
    component: () => import('./view/Mobile/Index'),
    meta:{title:'云上思念网上祭奠平台-网络祭拜网上祭扫-线上祭祀扫墓-为逝者创建网上纪念馆'}
  },





  {
    name: 'user',
    path: '/user',
    component: () => import('./view/user'),
    meta: {
      title: '会员中心',
    },
  },
  {
    name: 'cart',
    path: '/cart',
    component: () => import('./view/cart'),
    meta: {
      title: '购物车',
    },
  },
  {
    name: 'goods',
    path: '/goods',
    component: () => import('./view/goods'),
    meta: {
      title: '商品详情',
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
